import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'src/components/Button/ExternalLink';

export function LearnMoreSBOMButton({ href }: Readonly<{ href: string }>) {
  const { t } = useTranslation('createProduct');

  return <ExternalLink href={href}>{t('sbom.learnMoreSBOM')}</ExternalLink>;
}
